import ApiService from '@/services/common/api.service';

const CompanyManagementService = {
    listCompany,
};

/*
    List Company
*/
async function listCompany () {
    let url = '/companies';
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

export default CompanyManagementService;



// WEBPACK FOOTER //
// ./src/services/admin/company.service.js